import React from "react";
import { Header } from "semantic-ui-react";

import "./style.css";

const About = () => {
    return (
        <>
            <Header as="h1" id="about-header">About</Header>
        </>
    );
};

export default About;

